<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header d-flex">
        <h3 class="modal-title mr-auto">Добавить задачу в плановый сервис</h3>
        <h4 class="mb-0 align-self-center">{{date}}</h4>
        <button type="button" class="close ml-1" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="selectedTasks" class="modal-body pb-0">

        <div v-if="recommendation" class="alert alert-success d-flex align-items-center" role="alert">
          <div class="font-weight-bold">Рекомендуется перенести сервис на {{recommendation.recommended_date}}</div>
          <btn-action class="btn btn-sm btn-success ml-auto" @click="applyMoveRecommendation">Перенести</btn-action>
        </div>

        <div v-if="is_recommended" class="alert alert-success d-flex align-items-center" role="alert">
          <div class="font-weight-bold">Рекомендуется назначить этот сервис</div>
        </div>

        <div class="form-group">
          <label>Выберите исполнителя</label>
          <service-user-select
            :operator="default_operator"
            :tech="default_tech"
            :disabled="fromErp"
            :region-id="region_id"
            v-model="selectedOperator"
          />
        </div>

        <div v-if="!this.service_id" class="custom-control custom-checkbox my-2">
          <input class="custom-control-input" v-model="series" type="checkbox" value="" :id="`checkbox-series`">
          <label class="custom-control-label" :for="`checkbox-series`">Создать серию</label>
        </div>

        <div v-if="series" class="form-inline my-2">
            <div class="form-group">
              <label>Из</label>
              <input type="number" class="form-control series-input mx-2" v-model="count">
            </div>
          <div class="form-group">
            <span>С периодичностью</span>
            <input type="number" class="form-control series-input mx-2" v-model="period">
          </div>
        </div>

        <div class="form-group" v-if="tasksTypes && !fromErp">
          <label>Выберите задачи</label>
          <div v-for="task in tasksTypes" :key="task.id" class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              :id="task.id"
              autocomplete="off"
              :disabled="isDisabledTask(task) && !selectedTasks.includes(task.id)"
              v-model="selectedTasks"
              :value="task.id"
            />
            <label :for="task.id" class="custom-control-label">{{ task.name }}</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div>
          <btn-action
            v-if="$root.canCreateService() && !fromErp"
            class="btn btn-primary"
            :disabled="disabled"
            @click="save"
          >Назначить</btn-action>
          <btn-action
            v-if="$root.canCreateService() && !fromErp"
            class="btn btn-outline-danger ml-2"
            :disabled="done"
            @click="remove"
          >Удалить сервис</btn-action>
          <button
            v-if="$root.canCreateService() && fromErp"
            class="btn btn-outline-primary"
            disabled
          >Сервис из ERP недоступен для редактирования</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { find, filter } from 'lodash'
  import ServiceUserSelect from './service-user-select'

  export default {
    components: {ServiceUserSelect},
    props: [
      'machine_id',
      'date',
      'service',
      'default_tech',
      'default_operator',
      'region_id',
    ],
    data () {
      return {
        selectedOperator: this.service.executor || null,
        fromErp: false,
        term: null,
        service_id: this.service.id,
        is_recommended: this.service.is_recommended,
        done: this.service.done,
        recommendation: this.service.recommendation,
        showOperatorSelect: false,
        series: false,
        count: 1,
        period: 1,
      }
    },
    methods: {
      save () {
        if (this.selectedTasks.length === 0) {
          return this.remove()
        } else {
          let data = {
            task_types: this.selectedTasks,
            date: this.date,
            machine_id: this.machine_id,
            executor_id: this.selectedOperator.id,
          }

          let query
          if (this.service_id) {
            query = api.put(`services/planned/${this.service_id}`, data)
          } else {
            if (this.series) {
              data = Object.assign(data, {
                series: {
                  count: this.count || 1,
                  period: this.period || 1,
                },
              })
            }
            query = api.post('services/planned', data)
          }
          return query.then((data) => {
            this.$emit('hide', Object.assign(data.data, {deleted: false}))
          })
        }
      },
      applyMoveRecommendation () {
        // @todo: fix that blinking stays after service was moved
        return api.put(`services/planned/${this.service_id}`, {date: this.recommendation.recommended_date}).then((data) => {
          this.$emit('hide', Object.assign(data.data, {deleted: false}))
        })
      },
      remove () {
        if (window.confirm('Удалить сервис?')) {
          return api.delete(`services/planned/${this.service_id}`).then(() => {
            this.$emit('hide', {deleted: true})
          })
        }
      },
      getTaskNameById (id) {
        return find(this.allTasksTypes, {id}).name
      },
      isDisabledTask (task) {
        let tasksTypes = [
          'Плановое обслуживание',
          'Профилактическое обслуживание по месту установки (ППРт)',
          'Профилактическое обслуживание на складе (ППРс)',
        ]
        let checkTask = 'Проверка качества обслуживание и ремонта'
        return (this.disableSomeTasks && tasksTypes.includes(task.name)) ||
          (this.selectedTasks.length > 0 && ((this.getTaskNameById(this.selectedTasks[0]) !== checkTask && task.name === checkTask) || (this.getTaskNameById(this.selectedTasks[0]) === checkTask && task.name !== checkTask)))
      },
    },
    watch: {
      selectedOperator (newOperator, oldOperator) {
        if (oldOperator !== null) {
          this.selectedTasks = []
        }
      },
      count () {
        if (this.count !== '' && this.count < 1) {
          this.count = 1
        }
      },
      period () {
        if (this.period !== '' && this.period < 1) {
          this.period = 1
        }
      },
    },
    asyncComputed: {
      allTasksTypes () {
        return api.get('tasks').then(({data}) => data.data)
      },
      selectedTasks: {
        get () {
          if (!this.service_id) return []

          return api
            .get('services/planned/' + this.service_id)
            .then(({data}) => {
              this.fromErp = data.data.fromErp
              return data.data.tasks.map((task) => task.type.id)
            })
        },
        default: () => [],
      },
    },
    computed: {
      tasksTypes () {
        if (!this.selectedOperator) return

        // Filter tasks by role
        if (this.selectedOperator.role) {
          const serviceTasks = [
            'Инкассация',
            'Загрузка ингредиентов',
            'Выгрузка-загрузка монет',
            'Санитарная обработка',
          ]
          const techTasks = [
            'Инкассация',
            'Оперативный ремонт',
            'Плановое обслуживание',
            'Профилактическое обслуживание по месту установки (ППРт)',
            'Профилактическое обслуживание на складе (ППРс)',
            'Выгрузка-загрузка монет',
          ]
          let superiorTasks = [
            'Проверка качества обслуживание и ремонта',
          ]

          let availableTasks = []
          switch (this.selectedOperator.role.name) {
            case 'service': availableTasks = serviceTasks
              break
            case 'tech': availableTasks = techTasks
              break
            case 'service_superior': availableTasks = superiorTasks.concat(serviceTasks).concat(techTasks)
              break
            case 'tech_superior': availableTasks = superiorTasks.concat(techTasks)
          }

          return filter(this.allTasksTypes, (task) => availableTasks.includes(task.name))
        }

        return this.allTasksTypes
      },
      disabled () {
        return this.done || this.selectedOperator === null || (this.service_id === null && this.selectedTasks.length === 0)
      },
      disableSomeTasks () {
        let tasksTypes = [
          'Плановое обслуживание',
          'Профилактическое обслуживание по месту установки (ППРт)',
          'Профилактическое обслуживание на складе (ППРс)',
        ]
        return this.selectedTasks.some((taskId) => tasksTypes.includes(this.getTaskNameById(taskId)))
      },
    },
  }
</script>

<style lang="scss">
  .series-input {
    max-width: 10em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/service-modal-planned.vue